import Vue from 'vue'
import prepareQueryParamsMixin from '../../mixins/prepareQueryParamsMixin'
import prepareFetchParamsMixin from '../../mixins/prepareFetchParamsMixin'
import OtpInput from '@bachdgvn/vue-otp-input'
import JobService from '../../services/jobService'
import { showErrorToast, showSuccessToast } from '../../services/UI'
Vue.component('v-otp-input', OtpInput)
export default {
  name: 'earningsModal',
  mixins: [prepareQueryParamsMixin, prepareFetchParamsMixin],
  data () {
    return {
      mutableActived: this.activated,
      toggle: '',
      toggle2: ''
    }
  },
  props: ['activated', 'closeEarningsModal', 'applications', 'jobsFilled', 'jobId'],
  methods: {
    handleFileChange (e) {
      this.$emit('input', e.target.files[0])
    },
    closeJobModal (state) {
      this.closeEarningsModal(true, state)
      this.mutableActived = !this.mutableActived
      this.$el.blur()
    },
    async revoke () {
      const res = await JobService.revokeMiniJobOffers(this.jobId)
      if (res) {
        showSuccessToast(this, 'Job cancelled Successfully')
      } else {
        showErrorToast(this, 'Couldn\'t revoke job')
      }
      this.closeJobModal()
    },
    goback () {
      this.closeJobModal()
    }
    
  },
  watch: {
    activated (oldVal, newVal) {
      if (oldVal !== newVal && oldVal !== null) {
        this.mutableActived = !this.mutableActived
        this.$el.tabIndex = 1
        this.$nextTick(function () {
          this.$el.focus()
        })
      }
      this.toggle1 = this.applications.split('/')[0]
      this.toggle2 = this.jobsFilled.split('/')[0]
      console.log(this.jobId)
    }
  }
}
